import type {
  ConferencingToolType,
  ConferencingToolConfigs,
} from 'src/types/scheduler/conferencing-tools';

import type {Dispatch, ThunkAction} from 'src/reducers';

import * as reduxApi from 'src/utils/redux-api-v2';

import {camel} from 'src/utils';


export const SET_CONFERENCING_TOOL_CONFIGS = 'SET_CONFERENCING_TOOL_CONFIGS';

export type SchedulerConferencingToolsActions = SetConferencingToolConfigs;

export type SetConferencingToolConfigs = {
  type: typeof SET_CONFERENCING_TOOL_CONFIGS;
  payload: ConferencingToolConfigs;
};

export const setConferencingToolConfigs = (
  payload: ConferencingToolConfigs,
): SetConferencingToolConfigs => ({
  type: SET_CONFERENCING_TOOL_CONFIGS,
  payload,
});

export const fetchConferencingToolConfigs =
  (): ThunkAction => async (dispatch: Dispatch) => {
    try {
      const configs: ConferencingToolConfigs = await dispatch(
        reduxApi.get('scheduler/oauth/configs'),
      );
      dispatch(setConferencingToolConfigs(camel(configs)));
    } catch (error: any) {
      throw error;
    }
  };

export const connectConferencingTool =
  (tool: ConferencingToolType): ThunkAction<string> =>
  async (dispatch: Dispatch) => {
    try {
      const response: {auth_url: string} = await dispatch(
        reduxApi.get(`scheduler/oauth/${tool}/auth-url`),
      );
      return response.auth_url;
    } catch (error: any) {
      throw error;
    }
  };

export const deleteConferencingTool =
  (tool: ConferencingToolType): ThunkAction =>
  async (dispatch: Dispatch) => {
    try {
      await dispatch(reduxApi.del(`scheduler/oauth/${tool}/config`));
      // Refetch configs after deletion
      await dispatch(fetchConferencingToolConfigs());
    } catch (error: any) {
      throw error;
    }
  };
